import styled from 'styled-components';
import { breakpoints } from '../../../../styles/theme';
import { StockSliceStyled } from '../StockSliceStyled';
import { rem } from 'polished';

export const StockSliceStyledDS = styled(StockSliceStyled)`
    .header {
        border-top: 2px solid ${({ theme }) => theme.colors.grey16};

        &-location {
            align-items: center;
        }

        &-title {
            &-main {
                font-size: ${rem(24)};
                @media (min-width: ${breakpoints.sm}px) {
                    font-size: ${rem(32)};
                }
            }
            &-description {
                font-size: ${({ theme }) => theme.fontSizes.h5};
                margin: ${rem(14)} 0;
                @media (min-width: ${breakpoints.sm}px) {
                    font-size: ${({ theme }) => theme.fontSizes.h4};
                }
            }
        }
    }
`;
